import { useEffect, useState } from "react";
import imgOSM from "../images/tiles/OSM.png";
import imgRoadmap from "../images/tiles/Roadmap.png";
import imgTerrain from "../images/tiles/Terrain.png";
import imgAlteredRoadmap from "../images/tiles/Altered_roadmap.png";
import imgSatelliteOnly from "../images/tiles/Satellite_only.png";
import imgHybrid from "../images/tiles/Hybrid.png";
import imgRoad from "../images/tiles/Road.png";
import imgAerial from "../images/tiles/Aerial.png";
import imgAerialLabel from "../images/tiles/AerialLabel.png";
import { updateGroup } from "../services/settings";
import { removeAccents } from "../functions/removeAccents";
import { emptys, user } from "../data/main";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { CircularProgress } from "@mui/material";
import { strLang } from "../functions/strLang";
import { colorsList } from "../data/colorsList";

var tempTile = false;

export default function useSettings(props) {
  const { setGlobalUsers } = props;
  const [users, setUsers] = useState([]);
  const [searchUsers, setSearchUsers] = useState([]);
  const [tileInfo, setTileInfo] = useState({
    value: localStorage.getItem("tile"),
    label: strLang(localStorage.getItem("tile"), "tileNames"),
  });
  const imgList = {
    OSM: imgOSM,
    Roadmap: imgRoadmap,
    Terrain: imgTerrain,
    Altered_roadmap: imgAlteredRoadmap,
    Satellite_only: imgSatelliteOnly,
    Hybrid: imgHybrid,
    Road: imgRoad,
    Aerial: imgAerial,
    AerialLabel: imgAerialLabel,
  };
  const [tileImg, setTileImg] = useState(
    localStorage.getItem("tile")
      ? imgList[localStorage.getItem("tile")]
      : imgList.OSM
  );
  const [search, setSearch] = useState("");
  const [msgData, setMsgData] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let tempUsers = props.users.sort((a, b) =>
      a.NOMBRE < b.NOMBRE ? -1 : a.NOMBRE > b.NOMBRE ? 1 : 0
    );
    setUsers([...tempUsers]);
    setSearchUsers([...tempUsers]);
  }, [props.users]);

  useEffect(() => {
    updateUserList(search);
  }, [users]);

  const createHRef = (title, url) => {
    return (
      <div>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.open(url, "_blank").focus();
          }}
        >
          {title}
        </span>
      </div>
    );
  };

  const funcUpdateGroup = async (type, o) => {
    const results = await updateGroup(type, o);
    if (results && results.status) {
      if (type === "MAINGROUP") {
        let tileValue = emptys.includes(results.tile) ? "OSM" : results.tile;
        localStorage.setItem("tile", tileValue);
        user.tile = tileValue;
      }
      return true;
    }
    return false;
  };

  const changeTile = (e) => {
    setTileInfo(e);
    if (tempTile) {
      clearTimeout(tempTile);
    }
    tempTile = setTimeout(() => {
      funcUpdateGroup("MAINGROUP", {
        table: "TILE",
        value: e.value,
      });
      localStorage.setItem("tile", e.value);
    }, 1500);

    setTileImg(imgList[e.value]);
  };

  const updateUserList = (txt) => {
    setSearch(txt);
    setSearchUsers(
      txt === ""
        ? [...users]
        : [
            ...users.filter((o) => {
              let name = removeAccents(o.NOMBRE);
              return name.toLowerCase().includes(txt.toLowerCase());
            }),
          ]
    );
  };

  const updateUser = async (ord, type) => {
    let tempUsers = [...users];
    var index = tempUsers.findIndex((e) => e.ORD === ord);
    let value = !tempUsers[index][type];
    tempUsers[index][type] = -1;
    setUsers([...tempUsers]);
    const results = await funcUpdateGroup("UPDATEUSER", {
      id: ord,
      key: type,
      value: value ? 1 : 0,
    });
    // console.log(results);
    tempUsers[index][type] = results ? value : !value;
    setUsers([...tempUsers]);
  };

  const checkBox = (o, type) =>
    o[type] === -1 ? (
      <CircularProgress size={24} />
    ) : o[type] ? (
      <CheckBoxIcon
        style={{ color: "#289315", cursor: "pointer" }}
        onClick={() => {
          updateUser(o.ORD, type);
        }}
      />
    ) : (
      <CheckBoxOutlineBlankIcon
        style={{ cursor: "pointer" }}
        onClick={() => {
          updateUser(o.ORD, type);
        }}
      />
    );

  const startDelete = async () => {
    setOpen("loading");
    let responseDelete = await updateGroup("DELETEUSER", {
      id: msgData.id,
    });
    // console.log(responseDelete);
    if (responseDelete.status) {
      let tempUsers = [...users];
      let filteredUsers = tempUsers.filter((e) => e.ORD !== msgData.id);
      setGlobalUsers([...filteredUsers]);
      setUsers([...filteredUsers]);
      closeMsg();
    } else {
      setOpen("error");
    }
  };

  const closeMsg = () => {
    setOpen(false);
    setMsgData({});
  };

  const msgType = {
    askDelete: {
      title: strLang("askDeleteUser"),
      label: msgData.name,
      buttons: [
        {
          label: strLang("delete"),
          func: startDelete,
          width: 80,
          color: colorsList.red,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    loading: {
      type: "loading",
    },
    error: {
      type: "error",
      label: strLang("netWorkError"),
    },
  };

  return {
    tileImg,
    changeTile,
    search,
    updateUserList,
    searchUsers,
    checkBox,
    setMsgData,
    createHRef,
    msgType,
    open,
    closeMsg,
    setOpen,
    tileInfo,
  };
}
